import { render, staticRenderFns } from "./OppositePersonForm.vue?vue&type=template&id=0f90632e&scoped=true"
import script from "./OppositePersonForm.vue?vue&type=script&lang=js"
export * from "./OppositePersonForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f90632e",
  null
  
)

export default component.exports